import gql from 'graphql-tag';

const FRAGMENT_EVENT = gql`
  fragment eventDetails on Event {
    id
    code
    technicalDescription
    type
    color
    protocol {
      name
      id
    }
    eventGroup {
      id
      name
    }
    priority
    isMonitorable
  }
`;

export default {
  FRAGMENT_EVENT,
};
